const ActivityFeed = ({ activities, title, subtitle }) => {
  const getStatusColor = (type) => {
    const colors = {
      new: "#0ea5e9",
      message: "#22c55e",
      interview: "#fb923c",
      response: "#a855f7",
    };
    return colors[type] || "#64748b";
  };

  return (
    <div className="chart-container h-100 p-3">
      <h3 className="chart-title">{title}</h3>
      <h6 className="chart-subtitle">{subtitle}</h6>
      <div className="activity-feed">
        {activities.map((activity, index) => (
          <div key={index} className="activity-item">
            <div className="activity-content">
              <div className="activity-item">
                <div
                  className="activity-dot"
                  style={{ backgroundColor: getStatusColor(activity.type) }}
                />

                <div className="activity-content">
                  <div className="activity-title">{activity.title}</div>
                  <div className="activity-description">
                    {activity.description}
                  </div>
                  <div className="activity-time">{activity.time}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;
